<template>
	<div>
		<el-dialog :visible.sync="dailogStatus" width="800px" :before-close='handleClose'>
			<el-row style="padding:0 20px;float: none;font-size: 20px;">
				<el-col>
					<el-form :inline="true"  @submit.native.prevent>
						<el-form-item >
							<label style="font-size: 20px;" slot="label" >录入条码</label>
							<el-input style="width:280px;" v-model="scanningCode" @keyup.enter.native="searchScanningCode" placeholder="请录入条码"></el-input>
						</el-form-item>
					</el-form>
				</el-col>
			</el-row>
			<el-row style="padding:5px 20px;float: none;font-size: 20px;;">
				<el-col>
					条码信息
				</el-col>
			</el-row>
			<el-form :inline="true" class="form">
				<el-row style="padding:0 30px;float: none;">
					<el-col :span="20" :offset="1">
							<el-form-item label="名称:" :label-width="formLabelWidth">
								<span style="font-size: 20px;">{{msg.goodsName}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 30px;float: none;">
					<el-col :span="20" :offset="1">
							<el-form-item label="状态:" :label-width="formLabelWidth">
								<span style="font-size: 20px;">{{msg.customCodeStatus&&msg.customCodeStatus.name}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 30px;float: none;">
					<el-col :span="20" :offset="1">
							<el-form-item label="条码:" :label-width="formLabelWidth">
								<span style="font-size: 20px;color:#f56c6c">{{msg.customCode}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 30px;float: none;">
					<el-col :span="20" :offset="1">
							<el-form-item label="价格:" :label-width="formLabelWidth">
								<span style="font-size: 20px;">{{msg.min_price}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 30px;float: none;">
					<el-col :span="20" :offset="1">
							<el-form-item label="品牌:" :label-width="formLabelWidth">
								<span style="font-size: 20px;">{{msg.brand}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 30px;float: none;">
					<el-col :span="20" :offset="1">
							<el-form-item label="类型:" :label-width="formLabelWidth">
								<span style="font-size: 20px;">{{msg.categoryName}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 30px;float: none;">
					<el-col :span="20" :offset="1">
							<el-form-item label="规格:" :label-width="formLabelWidth">
								<span style="font-size: 20px;">{{msg.skuValue}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 30px;float: none;">
					<el-col :span="20" :offset="1">
							<el-form-item label="可使用(次):" :label-width="formLabelWidth">
								<span style="font-size: 20px;">{{msg.totaTimes}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 30px;float: none;">
					<el-col :span="20" :offset="1">
							<el-form-item label="已使用(次):" :label-width="formLabelWidth">
								<span style="font-size: 20px;">{{msg.useTimes}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 30px;float: none;">
					<el-col :span="20" :offset="1">
							<el-form-item label="单位:" :label-width="formLabelWidth">
								<span style="font-size: 20px;">{{msg.unit}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 30px;float: none;">
					<el-col :span="20" :offset="1">
							<el-form-item label="过期时间:" :label-width="formLabelWidth">
								<span style="font-size: 20px;">{{$public.FTime(msg.validityStopDate)}}</span>
								<span style="font-size: 20px;">{{msg.validityStopDate===''?'永不过期':''}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 30px;float: none;">
					<el-col :span="20" :offset="1">
							<el-form-item label="所在门店:" :label-width="formLabelWidth">
								<span style="font-size: 20px;" v-if="msg.currentShopId">{{$public.getShopNameById(msg.currentShopId)}}</span>
							</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dailogStatus:true,
				formLabelWidth:'100px',
				scanningCode:'',
				msg:{},
			}
		},
		mounted(){
		},
		methods: {
			handleClose(){
				this.$emit('close')
			},
			searchScanningCode(){
				this.getGoodsMsg(this.scanningCode);
			},
			// 获取商品信息
			getGoodsMsg(code) {
				this.scanningCode=''
				code = (code).toString().trim();
				this.$http.get(process.env.VUE_APP_Url_baseData + '/api/product/goods/from/code', {
					barcode: code
				}).then(res=>{
					if(res.code==0){
						this.msg = res.data;
					}
				})
			},
		},
	}
</script>

<style scoped lang="scss">
	.form{
		::v-deep .el-form-item{
			margin:5px 0;
		}
	}
</style>
